var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVariant1 = function SvgVariant1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 172 172"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A3A6B",
    d: "m88.573 19.276 19.312 25.397a102 102 0 0 0 19.442 19.442l25.397 19.312a3.233 3.233 0 0 1 0 5.146l-25.397 19.312a102 102 0 0 0-19.442 19.442l-19.312 25.397a3.233 3.233 0 0 1-5.146 0l-19.312-25.397a102 102 0 0 0-19.442-19.442L19.276 88.573a3.234 3.234 0 0 1 0-5.146l25.397-19.312a102 102 0 0 0 19.442-19.442l19.312-25.397a3.234 3.234 0 0 1 5.146 0"
  })));
};
export default SvgVariant1;